package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class QualityState(
    val id: String,
    quality: String = ""
) {
    var quality by mutableStateOf(quality)
}